// authentication options
export const APPLE = 'apple';
export const EMAIL = 'email';
export const FACEBOOK = 'facebook';
export const GOOGLE = 'google';

// session storage key(s)
export const HIDE_TIME_DELAY_MODAL = 'hide-time-delay-modal';
